$(document).ready(function () {
    // Array of product titles to match
    const productTitles = ["Crystal", "Executive", "Cherry Smash", "Fleur Noire", "Simply Santal", "Bold Love"];

    // Function to generate a random number between 350 and 600
    function generateRandomNumber(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    // Loop through all .grid-item__meta-main elements
    $('#CollectionSection-1525295772132 .grid-item__meta-main').each(function () {
      const $metaMain = $(this);

      // Find the .grid-product__title within this container
      const $titleElement = $metaMain.find('.grid-product__title');

      // Check if the title matches any product title in the array
      const productIndex = productTitles.indexOf($titleElement.text().trim());

      // Check if the title matches any product title in the array
      if ($titleElement.length && productIndex >= 0) {
        // Generate a random number for the #bought-section
        const upperBound = Math.max(350, 600 - (productIndex * 40)); // Ensure it doesn't go below 350
        const lowerBound = upperBound - 50;
        const randomCount = generateRandomNumber(lowerBound, upperBound); // Generate random number within the range

        const boughtSection = `
<div id="bought-section" style="display: flex;align-items: center; margin-top: 5px;border-radius: 50px; color: #85602c;">
  <!-- SVG Icon -->
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 17" width="30" height="17" fill="none" class="inline-block w-[22px] h-3" style="
    width: 23px;
    stroke: #85602c; /* Set stroke color */
">
    <circle cx="21.4443" cy="8.80469" r="7.66" stroke="black" stroke-width="0.68"></circle>
    <path d="M22.333 5.24902V9.69347" stroke="black" stroke-width="0.68" stroke-linecap="round" style="
    /* stroke: #85602c; */ /* Set stroke color */
    /* stroke-width: 1.5; */
"></path>
    <path d="M17.8887 9.69336L22.3331 9.69336" stroke="black" stroke-width="0.68" stroke-linecap="round"></path>
    <path d="M3.66699 4.80469L11.667 4.80469" stroke="black" stroke-width="0.68" stroke-linecap="round"></path>
    <path d="M1 8.80469L9 8.80469" stroke="black" stroke-width="0.68" stroke-linecap="round"></path>
    <path d="M3.66699 12.8047L11.667 12.8047" stroke="black" stroke-width="0.68" stroke-linecap="round"></path>
  </svg>

  <!-- Dynamic Text -->
  <span id="bought-text" style="margin-left: 4px;font-size: 12px;">
    <span id="view-num-ab" style="
    color: #85602c;
    font-weight: 600;
">${randomCount}</span> viewing!</span>
</div>
`;
        //insertion.
        let inserted = $metaMain.find('#bought-section').length > 0;
        if (!inserted) {
          $metaMain.find('.grid-product__vendor').after(boughtSection);
        }
      }
    });  
  });
